import axios from "axios";

export const baseUrl = process.env.REACT_APP_BASE_URL;

// export let baseUrl = "https://certage.0009.co/api/";

const redirectToMaintenanceIfNeeded = (response) => {
  if (
    response?.status === 503 &&
    response?.data?.maintenance === true &&
    window.location.pathname !== "/error"
  ) {
    //can't use navigate
    window.location.replace("/error?reason=maintenance");
  }
};

const api = async (path, params, method) => {
  let options = {
    headers: {
      "Content-Type": "application/json",
    },
    method: method,
    timeout: 30000,
    withCredentials: true,
    ...(params && { data: JSON.stringify(params) }),
  };

  return axios(baseUrl + path, options)
    .then((response) => {
      redirectToMaintenanceIfNeeded(response);

      return response;
    })
    .catch(async (error) => {
      const response = error.response;

      redirectToMaintenanceIfNeeded(response);

      return response;
    });
};

export default api;
